<!-- <template>
	<div class="marquee-wrap">
		<div class="scroll">
			<p class="marquee">{{text}}</p>
			<p class="copy"></p>
		</div>
		<p class="getWidth">{{text}}</p>
	</div>
</template>

<script>
	export default {
		name: 'marquee',
		props: ['val'],
		data() {
			return {
				timer: null,
				text: ''
			}
		},
		created() {
			let timer = setTimeout(() => {
				this.move()
				clearTimeout(timer)
			}, 1000)
		},
		mounted() {
			for (let item of this.val) {
				this.text += item
			}
		},
		methods: {
			move() {
				let maxWidth = document.querySelector('.marquee-wrap').clientWidth
				let width = document.querySelector('.getWidth').scrollWidth
				if (width <= maxWidth) return
				let scroll = document.querySelector('.scroll')
				let copy = document.querySelector('.copy')
				copy.innerText = this.text
				let distance = 0
				this.timer = setInterval(() => {
					distance -= 1
					if (-distance >= width) {
						distance = 16
					}
					scroll.style.transform = 'translateX(' + distance + 'px)'
				}, 20)
			}
		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	}
</script>

<style scoped>
	.marquee-wrap {
		width: 100%;
		overflow: hidden;
		position: relative;
	}

	.marquee {
		margin-right: 16px;
	}

	p {
		word-break: keep-all;
		white-space: nowrap;
		/* font-family: "微软雅黑 Light"; */
	}

	.scroll {
		display: flex;
	}

	.getWidth {
		word-break: keep-all;
		white-space: nowrap;
		position: absolute;
		opacity: 0;
		top: 0;
	}
</style>
 -->

<template>
	<div class="sizeScroll">
		<div class="content" ref="songName1">
			<div id="inner" :class="{innerActive: nameScroll}">
				<span ref="first" id="first">{{ val }}</span>
				<span id="second">{{ val }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'marquee',
		props: ['val'],
		data() {
			return {
				nameScroll: false
			}
		},
		mounted() {
			if (this.$refs.songName1.clientWidth < this.$refs.first.clientWidth) {
				this.nameScroll = true
			} else {
				this.nameScroll = false
			}
		}
	}
</script>

<style lang="less" scoped>
	.sizeScroll{
		.content {
			overflow: hidden;
			position: relative;
			height: 1vw;
			white-space: nowrap;
			display: flex;
			align-items: center;
		}
		#inner {
			position: absolute;
		}
		.innerActive{
			animation: slide 5s linear infinite;
			#first{
				margin-right: 8px;
			}
			#second{
				display: inline-block;
			}
		}

		#first{
			display: inline-block;
		}

		#second{
			display: none;
		}

		@keyframes slide {
			0% {
				transform: translateX(0);
			}
			100% {
				transform: translateX(-51%);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/marquee.vue